import { createRoutine } from 'redux-saga-routines';

const GET_FULL_ADDRESS_ACTION_PREFIX = 'GET_FULL_ADDRESS_ACTION';
export const getFullAddressAction = createRoutine(GET_FULL_ADDRESS_ACTION_PREFIX);
